/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react"
import { doc, collection, getDoc, DocumentSnapshot, setDoc, updateDoc } from 'firebase/firestore'
import { db } from '../../../firebase'
import { Box, Button, Typography, Table, TableBody, TableHead, TableRow, TableCell, TableContainer, Paper, Backdrop, CircularProgress, Modal } from "@mui/material"
import FormElement from "../../lib/FormElement"
import isEmpty from 'lodash.isempty'
import { validate } from "../../lib/FormValidation"
import parse from 'html-react-parser'
import dayjs from "dayjs"
import { toast } from 'react-toastify'
import { setIndividualStatus } from "./common"

type Props = {
  individualId: string
  isOpen: boolean
  onClose: (open: boolean) => void
}

const IndividualStatusModal = (props: Props) => {
  const { individualId, isOpen, onClose } = props
  const [open, setOpen] = useState<boolean>(false)
  const [forms, setForms] = useState<any>()
  const [formValues, setFormValues] = useState<any>()
  const [error, setError] = useState<string>('')
  const [prosessing, setProcessing] = useState<boolean>(false)
  const [individualInfo, setIndividualInfo] = useState<any>()

  useEffect(() => {
    setOpen(isOpen)
  }, [isOpen])

  useEffect(() => {
    getDoc(doc(collection(db, 'forms'), 'individualStatus')).then((_: DocumentSnapshot) => {
      _.exists() && setForms(_.data().conf)
    })
  }, [individualId])

  useEffect(() => {
    if(!forms) return
    const defaultValues = forms.reduce((a: any, b: any) => {
      a[b.name] = ""
      return a
    }, {})
    getDoc(doc(collection(db, 'individualStates'), individualId)).then((_: DocumentSnapshot) => {
      _.exists() ? setFormValues(_.data()) : setFormValues(defaultValues)
    })
    getDoc(doc(collection(db, 'individuals'), individualId)).then((_: DocumentSnapshot) => {
      _.exists() && setIndividualInfo(_.data())
    })
  }, [forms])

  const onChange = ({name, value}) => {
    setFormValues({...formValues, [name]: value})
  }
  const regist = async () => {
    const errors = forms.map((form: any) => {
      return validate(formValues[form.name], form.label, form.validation)
    })
    const errorMessages = errors.filter((e: any) => !isEmpty(e)).join("<br/>")
    if (!isEmpty(errorMessages)) {
      setError(errorMessages)
      return
    }
    setProcessing(true)
    try {
      await setDoc(doc(db, 'individualStates', individualId),
        {
          ...formValues,
          individualNo: individualInfo.individualNo,
          createdAt: dayjs().format('YYYY/MM/DD HH:mm')
        }
      )
      await updateDoc(doc(db, 'individuals', individualId),
        setIndividualStatus({
          ...individualInfo,
          demolitionPerson: formValues.demolitionPerson,
          demolitionDate: dayjs(formValues.demolitionDate).format('YYYY/MM/DD'),
          updatedAt: dayjs().format('YYYY/MM/DD HH:mm')
        })
      )
      toast.success("個体状態情報を登録しました")
      setError('')
    }
    catch (e) {
      toast.error(JSON.stringify(e))
    }
    finally {
      setProcessing(false)
      setOpen(false)
      onClose(false)
    }
  }

  const close = () => {
    setError("")
    setOpen(false)
    onClose(false)
  }

  const getValue = (name: string) => {
    return formValues[name]
  }

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      onClose={onClose}
    >
      <Box
        display="flex-col"
        justifyContent="center"
        alignItems="center"
        bgcolor="white"
      >
        <Box
          m={0}
          width="100vh"
          display="flex-col"
        >
          <Box display="flex" justifyContent="start" m={1}>
            <Typography variant="h5">{`個体識別番号：${individualInfo && individualInfo.individualNo}`}</Typography>
          </Box>
          <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
            <Table size="small" stickyHeader aria-label="simple table">
              <TableHead sx={{ m: 0 }}>
                <TableRow>
                  <TableCell align="left">項目</TableCell>
                  <TableCell width="20%" align="left">入力内容</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  forms && formValues && forms.map((form: any) => (
                    <TableRow
                      key={form.name}
                      className={!form.isHunterElements ? "bg-yellow-200" : ""}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {form.label}{form.type === 'checkbox' ? ` (${form.title})` : ""}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <FormElement
                          type={form.type}
                          name={form.name}
                          value={getValue(form.name)}
                          onChange={onChange}
                          options={form.options}
                          text={form.text}
                          // disabled={formDisabled}
                        />
                      </TableCell>
                    </TableRow>
                  ))
                }
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Box mt={1} display="flex" justifyContent="center">
          <Typography variant="body2" color="red">{parse(error)}</Typography>
        </Box>
        <Box display="flex" justifyContent="center">
          <Box m={1} display="flex" justifyContent="center">
            <Button variant="contained" color="secondary" onClick={() => close()}>閉じる</Button>
          </Box>
          <Box m={1} display="flex" justifyContent="center">
            <Button variant="contained" color="info" onClick={regist}>登録</Button>
          </Box>
        </Box>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={prosessing}
          onClick={() => setProcessing(false)}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Box>
    </Modal>

  )
}
export default IndividualStatusModal
